import { _ } from "libs";

import React from "react";
import { Form, Field } from "react-final-form";
import { Profile, Sport, Ratings } from "../../types";
import GenderSelect from "../forms/controls/genderSelect";
import DoBSelect, { parseDob, formatDob } from "../forms/controls/dobSelect";
import CitySelect from "../forms/controls/citySelect";
import SportSelect from "../forms/controls/sportSelect";
import SkillSelect from "../forms/controls/skillSelect";

type Props = {
	onChange: Function;
	profile: Profile;
	sports: Sport[];
	ratings: Ratings;
};

export function ProfileForm({ onChange, profile, sports, ratings }: Props) {
	return (
		<Form
			onSubmit={({ firstName, lastName, aboutMe, city, gender, dob, sport, rating }: any, mutators) => {
				let cityValue = "";
				if (city && city.hasOwnProperty("value")) {
					cityValue = city.value;
				}
				onChange({ firstName, lastName, aboutMe, city: cityValue, gender, dob, sport, rating });
			}}
			initialValues={{ ...profile }}
			render={({ handleSubmit, submitting, pristine, invalid, values }) => (
				<form onSubmit={handleSubmit} className="fullWidth floatingButtons">
					<Field name="firstName">
						{({ input, meta }) => (
							<div className="field medium">
								<label>{_("form.firstName.label")}</label>
								<input {...input} type="text" />
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="lastName">
						{({ input, meta }) => (
							<div className="field medium">
								<label>{_("form.lastName.label")}</label>
								<input {...input} type="text" />
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="aboutMe">
						{({ input, meta }) => (
							<div className="field medium">
								<label>{_("form.aboutMe.label")}</label>
								<textarea {...input} />
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="city">
						{({ input, meta, ...rest }) => (
							<div className="field medium">
								<label>{_("form.city.label")}</label>
								<div className="autosuggestText autosuggestCity">
									<CitySelect
										{...{ input, meta, ...rest }}
										// placeholder={_("onboarding.profileForm.city.placeholder")}
										getDisplayValue={(value) => {
											if (typeof value === "object") {
												return value.value;
											}
											return value;
										}}
									/>
								</div>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="gender">
						{({ input, meta, ...rest }) => (
							<div className="field medium">
								<label>{_("onboarding.profileForm.gender.label")}</label>
								<GenderSelect
									{...{ input, meta, ...rest }}
									prompt={_("onboarding.profileForm.gender.prompt")}
								/>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="dob" parse={parseDob} format={formatDob}>
						{({ input, meta, ...rest }) => (
							<div className="field medium">
								<label>{_("onboarding.profileForm.dob.label")}</label>
								<DoBSelect
									{...{ input, meta, ...rest }}
									dayPrompt={_("onboarding.profileForm.dob.dayPrompt")}
									monthPrompt={_("onboarding.profileForm.dob.monthPrompt")}
									yearPrompt={_("onboarding.profileForm.dob.yearPrompt")}
								/>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
								<p className="note small">{_("onboarding.profileForm.dob.description")}</p>
							</div>
						)}
					</Field>
					<Field name="sport">
						{({ input, meta, ...rest }) => (
							<div className="field medium">
								<label>{_("profileForm.sport.label")}</label>
								<SportSelect {...{ input, meta, ...rest }} prompt={null} sports={sports} />
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="rating">
						{({ input, meta, ...rest }) => (
							<div className="field">
								<label>{_("profileForm.skill.label")}</label>
								<SkillSelect
									{...{ input, meta, ratings, values, ...rest }}
									country={profile.rating && profile.rating.country ? profile.rating.country : null}
									rating={
										profile.rating && profile.rating.ratingValue ? profile.rating.ratingValue : null
									}
									userId={profile.userId}
									officialRating={
										profile.rating?.officialRating &&
										profile.rating?.officialRating.name &&
										profile.rating?.officialRating.code
											? profile.rating.officialRating
											: null
									}
								/>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<div className="buttons">
						<button type="submit" className="button fullWidth" disabled={submitting || invalid}>
							{_("saveBtn")}
						</button>
					</div>
				</form>
			)}
		/>
	);
}

export default ProfileForm;
